/**
 * Polish translations for PaymentQR screen
 */
export const paymentQRTranslationsPl = {
  // Screen
  screen: {
    title: 'Płatność turniejowa',
  },

  // Progress steps
  progress: {
    payment: 'Płatność',
    verification: 'Weryfikacja płatności',
    game: 'Gra',
  },

  // Timer
  timer: {
    label: 'Czas pozostały na płatność',
    expired: 'Wygasło',
  },

  // Instructions
  instructions: {
    title: 'Wpłać stake {amount} {currency}, aby utworzyć turniej',
    titleJoin: 'Wpłać stake {amount} {currency}, aby dołączyć do turnieju',
    description: 'Zapłać przez sieć POLYGON (MATIC) przy użyciu kodu QR lub MetaMask',
    subtitle: 'na ten adres depozytowy Trading Battles w sieci {network}.',
    awaitingPayment: 'Oczekiwanie na płatność...',
    dedicatedAddress: 'Adres depozytowy ·',
    copyAddress: 'Skopiuj adres',
    addressCopied: 'Skopiowano!',
    revealFull: 'Pokaż pełny',
    hide: 'Ukryj',
    sendHere: 'WYŚLIJ TUTAJ',
  },

  // Verify state (DS-2 Payment flow / VerifyScreen)
  verify: {
    title: 'Twoja płatność {amount} {currency} jest weryfikowana',
    subtitleCreate: 'Proszę czekać… Twój turniej zostanie utworzony po zaksięgowaniu płatności.',
    subtitleJoin: 'Proszę czekać… dołączysz do turnieju po zaksięgowaniu płatności.',
    transactionOn: 'Weryfikacja transakcji w sieci {network}…',
    backToPayment: 'Wróć do płatności',
  },

  // Status messages
  status: {
    confirmed: {
      title: 'Płatność potwierdzona',
      description: 'Twoja płatność została pomyślnie zweryfikowana. Publikowanie turnieju...',
      descriptionJoin: 'Twoja płatność została pomyślnie zweryfikowana. Dołączanie do turnieju...',
    },
    failed: {
      title: 'Płatność nieudana',
      description: 'Wystąpił problem z Twoją płatnością. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.',
    },
    expired: {
      title: 'Płatność wygasła',
      description: 'Czas na dokonanie płatności minął. Utwórz nową płatność, aby kontynuować.',
      descriptionJoin: 'Czas na dokonanie płatności minął. Spróbuj ponownie dołączyć do turnieju.',
    },
    refunded: {
      title: 'Płatność zwrócona',
      description: 'Twoja płatność została zwrócona. Skontaktuj się z pomocą techniczną, jeśli potrzebujesz pomocy.',
    },
    notAllowed: {
      title: 'Dołączenie niedozwolone',
      description: 'Nie możesz dołączyć do tego turnieju. Turniej może być pełny lub już się rozpoczął.',
    },
  },

  // Actions
  actions: {
    cancel: 'Anuluj',
    confirmPayment: 'Potwierdź płatność',
    retry: 'Ponów płatność',
    createNew: 'Nowa płatność',
    back: 'Wróć',
    contact: 'Kontakt',
  },

  // Errors
  errors: {
    publishFailed: 'Nie udało się opublikować turnieju: {message}',
    joinFailed: 'Nie udało się dołączyć do turnieju: {message}',
    loadFailed: 'Nie udało się załadować danych płatności',
    ownershipMismatch: 'Ta płatność należy do innego użytkownika',
    networkError: 'Błąd połączenia. Sprawdź połączenie z internetem.',
  },

  // Loading
  loading: {
    payment: 'Ładowanie płatności...',
    publishing: 'Publikowanie turnieju...',
    joining: 'Dołączanie do turnieju...',
  },
};

export type PaymentQRTranslationsPl = typeof paymentQRTranslationsPl;
